"use client";

import { createContext, type ReactNode, useContext } from "react";

const ResearchModeContext = createContext(false);

export function ResearchModeProvider({
  mode,
  children,
}: {
  mode: string | undefined;
  children?: ReactNode;
}) {
  return (
    <ResearchModeContext.Provider value={mode === "true"}>
      {children}
    </ResearchModeContext.Provider>
  );
}

export function useResearchMode() {
  return useContext(ResearchModeContext);
}
